import React, { FC, useCallback } from "react";
import { Map } from "immutable";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { OpenRightPanel } from "types/common/rightPanel";
import { openRightPanel } from "../../../../reduxFolder/reducers/rightPanel";
import { AddButton } from "../../../../components/Button";

interface AddPassportButtonProps {
  openRightPanel: OpenRightPanel;
}

const AddPassportButton: FC<AddPassportButtonProps> = React.memo(
  ({ openRightPanel }) => {
    const { t } = useTranslation("common");
    const handleClick = useCallback(
      () => openRightPanel("PASSPORT_FORM", Map({})),
      [openRightPanel],
    );

    return (
      <AddButton onClick={handleClick}>
        {t("books.passports.addPassport")}
      </AddButton>
    );
  },
);

const withConnect = connect(null, { openRightPanel });

export default withConnect(AddPassportButton);
